import { render, staticRenderFns } from "./otomatikkapanisfisi.vue?vue&type=template&id=7026e9b8"
import script from "./otomatikkapanisfisi.vue?vue&type=script&lang=js"
export * from "./otomatikkapanisfisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports